export default __webpack_public_path__ + "static/media/arrow_expanded.b701f8a4.svg";